import Vue from 'vue'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

Vue.use(VuePlyr, {
    plyr: {
        iconUrl: '/assets/plyr.svg'
    }
})
